import JSZip from 'jszip';
import { StudentData } from '../types';

function generateHtmlReport(data: StudentData): string {
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${data.student.studentName} - 课堂评价报告</title>
  <style>
    body { font-family: "Microsoft YaHei", Arial, sans-serif; max-width: 800px; margin: 40px auto; padding: 20px; background: #f5f5f5; }
    .card { background: white; border-radius: 12px; padding: 30px; margin-bottom: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
    h1 { color: #1a73e8; margin-bottom: 10px; }
    .meta { color: #666; font-size: 14px; margin-bottom: 20px; }
    .section { margin: 20px 0; }
    .section h2 { color: #333; font-size: 18px; border-bottom: 2px solid #1a73e8; padding-bottom: 8px; }
    .score-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-top: 15px; }
    .score-item { background: #f0f4ff; padding: 12px; border-radius: 8px; text-align: center; }
    .score-value { font-size: 24px; font-weight: bold; color: #1a73e8; }
    .score-label { font-size: 12px; color: #666; }
    .report-text { line-height: 1.8; color: #444; white-space: pre-wrap; }
  </style>
</head>
<body>
  <div class="card">
    <h1>${data.student.studentName}</h1>
    <div class="meta">
      班级: ${data.student.className} | 组别: ${data.student.groupId} | 学号: ${data.student.studentId.split('_')[1]}
    </div>

    <div class="section">
      <h2>📊 自评得分</h2>
      <div class="score-grid">
        <div class="score-item">
          <div class="score-value">${data.selfEval.q1Participation}</div>
          <div class="score-label">运动参与</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q2Resilience}</div>
          <div class="score-label">意志力</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q3SkillKnow}</div>
          <div class="score-label">技能认知</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q4SkillImprove}</div>
          <div class="score-label">技能提升</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q5HealthSafe}</div>
          <div class="score-label">健康安全</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q6HealthPrep}</div>
          <div class="score-label">健康准备</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q7MoralQueue}</div>
          <div class="score-label">品德守序</div>
        </div>
        <div class="score-item">
          <div class="score-value">${data.selfEval.q8MoralEncourage}</div>
          <div class="score-label">品德激励</div>
        </div>
      </div>
    </div>

    <div class="section">
      <h2>📝 微观评语</h2>
      <div class="report-text">${data.microReport || '暂无评语'}</div>
    </div>
  </div>
</body>
</html>`;
}

export async function generateHtmlZip(studentDataList: StudentData[]): Promise<Blob> {
  const zip = new JSZip();

  for (const data of studentDataList) {
    const fileName = `${data.student.studentName}_${data.student.studentId}.html`;
    zip.file(fileName, generateHtmlReport(data));
  }

  return await zip.generateAsync({ type: 'blob' });
}